import { render, staticRenderFns } from "./travelList.vue?vue&type=template&id=3e935620&scoped=true&lang=html&"
import script from "./travelList.vue?vue&type=script&lang=js&"
export * from "./travelList.vue?vue&type=script&lang=js&"
import style0 from "./travelList.vue?vue&type=style&index=0&id=3e935620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e935620",
  null
  
)

export default component.exports